import { EventsList } from '../../../components/Events/EventsList'

export const EventsRequestsPage = () => <EventsList scope="requests" />
